import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import GalleryIcon from "src/assets/all-icons/gallery-icon.jsx";

import useStateHandler from '@/hooks/useStateHandler';
import AuthService from '@/services/auth.service';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import PublicFormInput from '@/shared-components/inputs/components/PublicFormInput';
import Text from '@/shared-components/text/components/Text';

// eslint-disable-next-line no-unused-vars
import AuthGoogle from './AuthGoogle';

import './styles/AuthRegularSignup.css';

// eslint-disable-next-line no-unused-vars
export default function AuthRegularSignup({ close }) {
  const { state, stateHandler } = useStateHandler();
  const [formData, setFormData] = useState({
    user_email: "",
    user_password: "",
    user_confirm_password: ""
  });
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const onInputChange = (e) => {
    const value = e.target.value;
    const key = e.target.name;
    setFormData({
      ...formData,
      [key]: value,
    });
    setError(null);
  };

  const continueButtonDisabled = 
    !formData.user_email ||
    !formData.user_password ||
    !formData.user_confirm_password ||   
    !termsAccepted || 
    error ;

  async function signUpSubmit(e) {
    e.preventDefault();
    setLoading(true); 
    setError(null); 

    if(!termsAccepted) {
      setError({ element: "user_terms", error_code: "TERMS_NOT_ACCEPTED" });
      setLoading(false);
      return;
    }

    if(e.target.user_password.value !== e.target.user_confirm_password.value) {
      setError({ element: "user_confirm_password", error_code: "PASSWORD_MISMATCH" });
      setLoading(false);
      return;
    }

    const { response, data } = await AuthService.registerCollector(e.target.user_email.value, e.target.user_password.value, state.invite);

    if(response.ok) {
      AuthService.initUserSession(stateHandler, setLoading, data);
    }else if(response.status === 400) {
      setLoading(false);
      setError({ element: data.error_data.element, error_code: data.error_type });
    }
  }

  const onRequestGalleryAccessClick = () => {
    window.open("https://join.suarte.art/form", "_blank");
  };

  return (
    <>
      <div className="auth-regular_header-container">
        <p className="auth-regular_header-text">New here? Sign up below to begin your journey.</p>
      </div>
      <form onSubmit={signUpSubmit} className="auth-regular-signup__form">
        <PublicFormInput error={error} value={formData.user_email} onChange={onInputChange} placeholder="Email" element="user_email" type="email" margin/>
        <PublicFormInput error={error} value={formData.user_password} onChange={onInputChange} placeholder="Password" element="user_password" type="password" margin/>
        <PublicFormInput error={error} value={formData.user_confirm_password} onChange={onInputChange} className="auth-regular-signup__input-margin" placeholder="Confirm password" element="user_confirm_password" type="password"/>

        <PublicFormInput error={error} className="auth-regular-signup_accept-conditions" element="user_terms" type="checkbox" value={termsAccepted} onChange={value => setTermsAccepted(value)}>
                    I agree to the <span className="auth-regular-signup__terms" onClick={()=>navigate("/terms", { state: { from: true } })}>Terms and Conditions</span> and confirm I am 18 or older.
        </PublicFormInput>
                             
        <ContinueButton loading={loading} turnOff={continueButtonDisabled} className="auth-regular-signup__submit-button"> 
                    Continue 
        </ContinueButton>
      </form>
            
      {/* <Text className="auth-regular-signup__or" small>If you prefer, you can</Text> */}

      {/* <AuthGoogle className="auth-regular-sgnup__google" close={close} textButton='Sign up with Google' /> */}

      <div className="auth-signup-selector__container" onClick={onRequestGalleryAccessClick}>
        <div className="auth-signup-selector__icon-box">
          <GalleryIcon className="auth-sign-up-selector__icon"/>
        </div>

        <Text className="auth-signup-selector__text" medium>
                    Request Gallery Access
        </Text>
      </div>
    </>
  );
}
